module.exports = "/_next/static/images/medium-15710e63ff28228644eebe3b9076f9ce.svg";